import type { HrisImportLogState } from './hris-import-log-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import { Action, updateResourceByParam } from '../reducers/utils/state-manager';

import { HrisImportLog } from '../typescript-types/hris-import-log';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState: HrisImportLogState = {
  hrisImportLogsById: {},
  hrisImportLogsStateByMergeIntegrationId: {},
  hrisImportEmployeeChangeLogsById: {},
  hrisImportEmployeeChangeLogsStateByHrisImportLogId: {},
};

export const hrisImportLogReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_HRIS_IMPORT_LOGS'): {
      const { mergeIntegrationId } = action.payload.args;
      return updateResourceByParam(
        state,
        'hrisImportLogs',
        'mergeIntegrationId',
        mergeIntegrationId,
        true,
      );
    }
    case SUCCESS('LOAD_HRIS_IMPORT_LOGS'): {
      const {
        args: { mergeIntegrationId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'hrisImportLogs',
        'mergeIntegrationId',
        mergeIntegrationId,
        false,
        convertArrayToMap(data, (d: HrisImportLog) => String(d.hrisImportLogId)),
      );
    }
    case FAILURE('LOAD_HRIS_IMPORT_LOGS'): {
      const { mergeIntegrationId } = action.payload.args;
      return updateResourceByParam(
        state,
        'hrisImportLogs',
        'mergeIntegrationId',
        mergeIntegrationId,
        false,
      );
    }
    case STARTING('LOAD_HRIS_IMPORT_EMPLOYEE_CHANGE_LOGS'): {
      const { hrisImportLogId } = action.payload.args;
      return updateResourceByParam(
        state,
        'hrisImportEmployeeChangeLogs',
        'hrisImportLogId',
        hrisImportLogId,
        true,
      );
    }
    case SUCCESS('LOAD_HRIS_IMPORT_EMPLOYEE_CHANGE_LOGS'): {
      const {
        args: { hrisImportLogId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'hrisImportEmployeeChangeLogs',
        'hrisImportLogId',
        hrisImportLogId,
        false,
        { [hrisImportLogId]: data },
      );
    }
    case FAILURE('LOAD_HRIS_IMPORT_EMPLOYEE_CHANGE_LOGS'): {
      const { hrisImportLogId } = action.payload.args;
      return updateResourceByParam(
        state,
        'hrisImportEmployeeChangeLogs',
        'hrisImportLogId',
        hrisImportLogId,
        false,
      );
    }
    default: {
      return state;
    }
  }
};
